import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import { currentUser } from 'helpers/globals'

class MobileError extends React.Component {
  state = { testing: false, siteAccess: null, dbAccess: null }

  testConnections = _ => {
    this.setState({ testing: true })

    axios.get(`${IPVM_URL}/${currentUser}`)
      .then(res =>
        this.setState({ siteAccess: res.status < 400 })
      )
      .catch(e =>
        this.setState({ siteAccess: false })
      )

    axios.get(CLOUDANT_URL)
      .then(res =>
        this.setState({ dbAccess: res.status < 400 })
      )
      .catch(e =>
        this.setState({ dbAccess: false })
      )
  }

  testingComplete = _ =>
    this.state.testing && this.state.siteAccess !== null && this.state.dbAccess !== null

  connectionFailed = _ =>
    this.state.testing && (this.state.siteAccess === false || this.state.dbAccess === false)

  renderResult = key => {
    const { state, props: { classes } } = this

    if (state[key] !== false) return null

    return (
      <div key={key} className={classes.result}>
        <FontAwesomeIcon icon='times' className={classes.failIcon} />
        <span>
          Cannot connect to { ' ' }
          { key === 'siteAccess' ? <a href={ IPVM_URL } target='_blank'>{ IPVM_URL }</a> : <a href={ CLOUDANT_URL } target='_blank'>{ CLOUDANT_URL }</a> }
          . Please unblock this URL.
        </span>
      </div>
    )
  }

  componentDidMount = _ => this.testConnections()

  render() {
    const { testingComplete, connectionFailed, renderResult, props: { classes } } = this

    return (
      <div className={classes.dialog}>
        <div className={classes.header}>
          Error Loading Designer / Calculator
        </div>
        <div className={classes.body}>
          The IPVM Designer / Calculator cannot open.
          { ['siteAccess', 'dbAccess'].map(key => renderResult(key)) }
          { testingComplete() &&
            <p className={classes.text}>
              <span>{ connectionFailed() ? 'If you still cannot connect or need help, ' : 'Please ' }</span>
              <a href={`${IPVM_URL}/contact?subject='Calculator unable to load'`} target='_blank'>contact us for assistance.</a>
            </p>
          }
        </div>
      </div>
    )
  }
}

export default (injectSheet(style)(MobileError))



// WEBPACK FOOTER //
// ./src/components/MobileStart/MobileError/index.js